module.exports = __webpack_public_path__ + "static/img/logo_white.ddf5aee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.jpeg
// module id = wSEY
// module chunks = 13